import React from 'react'
import "./section.css";

const RightSection = () => {
    return( 
    <div id="right-sec-text">
        <h4>World without trees </h4>
        <ul>
            <li>No Trees... No Humans.</li>
            <li>Higher amounts of carbon</li>
            <li>Filthy air</li>
            <li>Destruction of many organisms</li>
            <li>Climate change and enviornment destruction</li>
        </ul>
    </div>
     
    )
}

  

export default RightSection;


